let unit_pbgid = require("../../config/all-unified-techs.json")

function getIconByPbgid(_pbgid) {
    for (const units of Object.values(unit_pbgid)) {
        const match = units.find(unit => unit.pbgid === _pbgid);
        if (match) return match.icon;
    }
    return null; // not found
}

function getMaliIconByPbgid(_pbgid) {
    if (_pbgid === 9000375) { return '/liveGameIcons/unique/mali/musofadi_farimba.png' }
    if (_pbgid === 9000508) { return '/liveGameIcons/unique/mali/musofadi_farimba.png' }
    if (_pbgid === 9000376) { return '/liveGameIcons/unique/mali/javelin_thrower_mansa.png' }
    if (_pbgid === 9000509) { return '/liveGameIcons/unique/mali/javelin_thrower_mansa.png' }
    if (_pbgid === 9000377) { return '/liveGameIcons/unique/mali/musofadi_mansa.png' }
    if (_pbgid === 9000510) { return '/liveGameIcons/unique/mali/musofadi_mansa.png' }
    return null; // not found
}

export function LiveGameTechDisplay({ pbg_id, hasTech }) {

    if (pbg_id === "gapper") {
        return <div className="w-10 h-10"></div>
    }

    pbg_id = parseInt(pbg_id)

    let background = pbg_id ? `/liveGameIcons/tech_background.png` : `/liveGameIcons/empty_background.png`
    let icon = getIconByPbgid(pbg_id) || getMaliIconByPbgid(pbg_id) || '/liveGameIcons/unknown.png'


    return (
        <div className="w-10 h-10 border-solid-1" style={{
            backgroundImage: `url(${background})`,
            borderColor: 'var(--main-color)',
            filter: !hasTech && 'brightness(40%)'
        }}>
            {icon && <img src={icon} alt="" />}
        </div>
    )
}